import { useMedia } from 'react-use';

declare global {
  interface Window {
    __IS_MOBILE__?: boolean;
  }
}

export function useIsMobile(): boolean {
  const isMobileWidth = useMedia('(max-width: 781px)');
  const isLandscape = useMedia(
    '(orientation: landscape) and (max-height: 781px)'
  );
  return isMobileWidth || isLandscape || !!window.__IS_MOBILE__;
}
